import { render, staticRenderFns } from "./detailVirtualHolev.vue?vue&type=template&id=2797407b&scoped=true"
import script from "./detailVirtualHolev.vue?vue&type=script&lang=js"
export * from "./detailVirtualHolev.vue?vue&type=script&lang=js"
import style0 from "./detailVirtualHolev.vue?vue&type=style&index=0&id=2797407b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2797407b",
  null
  
)

export default component.exports